'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullStoryLoader = function () {
  function FullStoryLoader(options) {
    (0, _classCallCheck3.default)(this, FullStoryLoader);

    this._options = options;
    this._isChild = false;
  }

  (0, _createClass3.default)(FullStoryLoader, [{
    key: '_prepareFullStoryPlaceholder',
    value: function _prepareFullStoryPlaceholder() {
      var g = window.FS = function (a, b) {
        return g.q ? g.q.push([a, b]) : g._api(a, b);
      };
      FS.setUserVars = function (v) {
        return v && g('user', v);
      };
      FS.identify = function (i, v) {
        g('user', { uid: i });
        g.setUserVars(v);
      };
      FS.event = function (n, p, s) {
        return g('event', { n: n, p: p, s: s });
      };
      FS.q = [];
    }
  }, {
    key: '_configureFullStoryGlobals',
    value: function _configureFullStoryGlobals() {
      window._fs_debug = false;
      window._fs_host = this._options.host || 'www.fullstory.com';
      window._fs_org = this._options.org || '1zuo';
      if (this._isChild) {
        window._fs_run_in_iframe = true;
      } else if (window !== window.top) {
        window._fs_is_outer_script = true;
      }
    }
  }, {
    key: '_load',
    value: function _load() {
      this._prepareFullStoryPlaceholder();
      this._configureFullStoryGlobals();
    }
  }, {
    key: '_qaGlassbox',
    value: function _qaGlassbox() {
      return window.location.toString().indexOf('qagb') !== -1 || this._options.qagb === true;
    }
  }, {
    key: 'setup',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._qaGlassbox()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                this._isChild = window !== window.top;

                if (!this._isChild) {
                  this._load();
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setup() {
        return _ref.apply(this, arguments);
      }

      return setup;
    }()
  }]);
  return FullStoryLoader;
}();

exports.default = FullStoryLoader;